/**
 * Esta función se encarga de extraer los nombres del header que se esperan obtener en las hojas del Excel. Esta función extrae los textos según los idiomas que se encuentren en la variable de entorno REACT_APP_IDIOMAS_DISPONIBLES, pero si este idioma no existe en el excel donde se encuentran todos los textos, no la utiliza para evitar errores
 * 
 * @param advertencias: object
 * @param camposObligatorios: object
 * @param nombreHoja: string
 * @param seccion: string
 * @param textosTabla: object
 * 
 * advertencias: Corresponde al objeto de advertencias que se teiene el el hook de useObtenerDatosExcel.
 * camposObligatorios: Corresponde a la sección que se desea consultar (profesores, cursos, estudiantes)
 * nombreHoja: Corresponde a la sección que se desea consultar (profesores, cursos, estudiantes)
 * seccion: Corresponde a la sección que se desea consultar (profesores, cursos, estudiantes)
 * textosTabla: Corresponde a los textos relacionados de la hoja que hace referencia a los datos del Excel según la sección que se está consultando.
 * 
 * @returns columnas: object
 * 
 * columnas: Es un objeto que obtine el hombre del header esperado y si dicho campo es obligatorio. Estas propiedades se almacenan en 2 propiedades:
 *  - campo: Es un string que corresponde al nombre del campo esperado dentro del Excel
 *  - obligatorio: Es un booleano que indica si es obligatorio. Si es true es obligatorio, si es false es opcional
**/

  //Advertencias campos incorrectos
  const advertenciasCamposIncompletos = ({ advertencias, camposObligatorios, nombreHoja, seccion, textosTabla }) => {
    let camposFaltantes = [];
    let hoja = {};
    for (const key in camposObligatorios.campos) {
      const element = camposObligatorios.campos[key];
      element === undefined && camposFaltantes.push(key)
    }

    if (!!nombreHoja) {
      hoja = !!advertencias[seccion]?.header?.campos ? { ...advertencias[seccion].header.campos, [nombreHoja]: camposFaltantes } : { [nombreHoja]: camposFaltantes }
    };


    advertencias[seccion] = {
      ...advertencias[seccion], header: {
        campos: !!nombreHoja ? hoja : camposFaltantes,
        mensaje: textosTabla.advertencias[seccion].campos.descripcion,
        titulo: textosTabla.advertencias[seccion].campos.titulo,
      }
    };

    return advertencias
}
  
export default advertenciasCamposIncompletos;